(function () {
    "use strict";

    angular
        .module("app")
        .directive("developmentCenterSelector", ["$window", "$uibModal", "toaster", "QUtil", "PatternService", developmentCenterSelector]);

    function developmentCenterSelector($window, $uibModal, toaster, qUtil, patternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.params = {};

                scope.load = function (id) {
                    if (!id) {
                        scope.selectedDevCenters = [];
                        scope.updateText();
                        return;
                    }

                    patternService.getDevelopmentCentersForPattern(id).then(function (data) {
                        scope.ensureFullName(data);
                        scope.selectedDevCenters = data;
                        scope.revertData.selectedDevCenters = angular.copy(data);
                        scope.updateText();

                        _.each(data, function (d) {
                            scope.removeAllDevCenter(d.DevelopmentCenterId);
                        });

                    });
                };

                scope.selectDevCenter = function () {
                    var devCenter = scope.params.selectedDevCenter;

                    if (!devCenter) return;

                    scope.selectedDevCenters.push(devCenter);
                    scope.removeAllDevCenter(devCenter.DevelopmentCenterId);
                    scope.updateText();
                };

                scope.removeAllDevCenter = function (id) {
                    var index = _.findIndex(scope.allDevCenters, function (d) {
                        return d.DevelopmentCenterId === id;
                    });

                    if (index >= 0)
                        scope.allDevCenters.splice(index, 1);
                };

                scope.remove = function (indx) {
                    var item = scope.selectedDevCenters[indx];
                    scope.selectedDevCenters.splice(indx, 1);
                    scope.allDevCenters.push(item);
                    scope.allDevCenters = _.sortBy(scope.allDevCenters, "DevelopmentCenterName");
                    scope.updateText();
                };

                scope.save = function (form) {
                    if (form.$valid === false) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Please review all fields indicated in red.", timeout: 5000 });
                        return;
                    }

                    toaster.clear();
                    scope.selectedDevCenters = _.sortBy(scope.selectedDevCenters, "row");
                    scope.closeModal(form, false);
                    scope.updateText();
                };

                scope.showFunc = function () {
                    scope.modal = $uibModal.open({
                        scope: scope,
                        templateUrl: templateUrl("app/directives/pattern/developmentCenterSelector-modal.directive.html"),
                        backdrop: "static",
                        size: "lg",
                        windowClass: "modal-bottom-options"
                    });
                };

                scope.closeModal = function (form, cancel) {
                    scope.modal.close();

                    scope.hasChanges = form.$dirty;

                    if (cancel) {
                        scope.revert();
                    } else {
                        scope.revertData.selectedDevCenters = angular.copy(scope.selectedDevCenters);
                        scope.revertData.allDevCenters = angular.copy(scope.allDevCenters);
                    }

                    if (angular.isFunction(scope.onClose)) {
                        scope.onClose({ hasChanges: scope.hasChanges });
                    }
                };

                scope.revert = function () {
                    scope.hasChanges = false;
                    scope.selectedDevCenters = angular.copy(scope.revertData.selectedDevCenters);
                    scope.allDevCenters = angular.copy(scope.revertData.allDevCenters);
                    scope.updateText();
                }

                scope.updateText = function () {
                    scope.text = "";

                    if (scope.selectedDevCenters.length > 0) {
                        var first = _.find(scope.selectedDevCenters, function (d) { return d.row === 0; }) ||
                            scope.selectedDevCenters[0];
                        scope.text = first.FullName;
                    }

                    if (scope.selectedDevCenters.length > 1) {
                        scope.text = scope.text + "  (+ " + (scope.selectedDevCenters.length - 1).toString() + " more)";
                    }
                };

                scope.ensureFullName = function(devCenters) {
                    _.each(devCenters, function (d) { d.FullName = d.DevelopmentCenterName + " (" + d.DevelopmentCenterKey + ")"; });
                }

                scope.init = function () {
                    scope.text = scope.text === undefined ? undefined : scope.text;
                    scope.hasChanges = false;

                    qUtil.whenAll([
                        function () {
                            return patternService.getAllDevelopmentCenters().then(function (data) {
                                data = _.filter(data, function (d) { return d.IsActive });
                                scope.ensureFullName(data);

                                scope.allDevCenters = data;
                                scope.revertData = {
                                    allDevCenters: angular.copy(data),
                                    selectedDevCenters: []
                                }
                            });
                        }
                    ]).then(function () {
                        scope.load(scope.patternId);
                    });

                    scope.$watch("patternId", function (newValue) {
                        scope.load(newValue);
                    });

                    scope.gridsterOpts = {
                        columns: 1, // the width of the grid, in columns
                        pushing: true, // whether to push other items out of the way on move or resize
                        floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                        swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                        width: "auto", // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                        colWidth: "auto", // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                        rowHeight: "40", // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                        margins: [0, 0], // the pixel distance between each widget
                        outerMargin: false, // whether margins apply to outer edges of the grid
                        sparse: false, // "true" can increase performance of dragging and resizing for big grid (e.g. 20x50)
                        isMobile: false, // stacks the grid items if true
                        mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
                        mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                        minColumns: 1, // the minimum columns the grid must have
                        minRows: 2, // the minimum height of the grid, in rows
                        maxRows: 200,
                        defaultSizeX: 1, // the default width of a gridster item, if not specifed
                        defaultSizeY: 1, // the default height of a gridster item, if not specified
                        minSizeX: 1, // minimum column width of an item
                        maxSizeX: 1, // maximum column width of an item
                        minSizeY: 1, // minumum row height of an item
                        maxSizeY: 1, // maximum row height of an item,
                        defaultCol: 0,
                        resizable: {
                            enabled: false
                        },
                        draggable: {
                            enabled: true, // whether dragging items is supported
                            handle: ".gridster-handle", // optional selector for drag handle
                            stop: function (event, $element, widget) {
                                scope.updateText();
                            }
                        }
                    };
                };

                scope.init();

            },
            scope: { patternId: "=", showFunc: "=?", readOnly: "=", selectedDevCenters: "=?", text: "=?", onClose: "&?" },
            templateUrl: templateUrl("app/directives/pattern/developmentCenterSelector-summary.directive.html")
        };
    }
})();

